import React, { useCallback, useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { MeCollection } from '../../swagger/collections-identity';
import { NotLoggedInPage, FormInfo, InputFieldType } from '@ydistri/ds';
import { Alert } from 'antd';
import { passwordMessages } from '@ydistri/utils';

const confirmAccountInputs: InputFieldType[] = [
  {
    title: 'New password',
    type: 'password',
    name: 'confirm_new_pass_1',
    validation: { type: 'password' },
  },
  {
    title: 'Confirm password',
    type: 'password',
    name: 'confirm_new_pass_2',
    validation: { type: 'must_match', field: 'confirm_new_pass_1' },
  },
];

const ConfirmAccount: React.FC = () => {
  const navigate = useNavigate();
  const { search } = useLocation();
  const token = new URLSearchParams(search).get('token') ?? '';
  const email = new URLSearchParams(search).get('email') ?? '';
  const [submitting, setSubmitting] = useState<boolean>(false);
  const [error, setError] = useState<string>();

  const infoTop = useMemo(() => <FormInfo>{passwordMessages.hint}</FormInfo>, []);

  const infoBottom = useMemo(() => error && <Alert type="error" message={error} />, [error]);

  const onSubmit = useCallback(
    (values: Record<string, string>) => {
      setError(undefined);
      setSubmitting(true);
      MeCollection.confirmAccountCreate(
        {
          login: email,
          newPassword: values.confirm_new_pass_1,
        },
        {
          headers: { resetToken: token },
        },
      )
        .then(() => {
          setSubmitting(false);
          navigate(`/login?activation=${Date.now()}`);
        })
        .catch((e: unknown) => {
          // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- it is error
          const error = e as Error;
          setError(error.message);
          setSubmitting(false);
        });
    },
    [token, email, navigate],
  );

  if (token === '' || email === '')
    return <p>An error has occurred - no login or token present.</p>;

  return (
    <NotLoggedInPage
      title="Activate account"
      inputs={confirmAccountInputs}
      button="Activate account"
      onSubmit={onSubmit}
      submitting={submitting}
      infoTop={infoTop}
      infoBottom={infoBottom}
    >
      {null}
    </NotLoggedInPage>
  );
};

export default ConfirmAccount;
